<template>
  <div class="learning_duration_wrap">
    <el-button class="go_back" @click="goBack">返回</el-button>
    <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
      <el-tab-pane label="今日学习时长排行" name="first">
        <el-table
          v-if="activeName=='first'"
          :data="tableData"
          style="width: 100%;margin-top:16px"
          :header-cell-style="{background:'#EDF4FE'}"
          :height="height-160"
          class="collegeTable"
        >
          <el-table-column prop="num" label="名次"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="time" label="学习时长"></el-table-column>
        </el-table>
        <pagination
          :currentpage="pageTotal.currentPage"
          :pageSize="pageTotal.pageSize"
          :total="pageTotal.total"
          layout="prev, pager, next, jumper"
          v-on:currentPageFn="currentPageFn"
          :current-page.sync="pageTotal.currentPage"
          v-if="tableData.length && (pageTotal.total>pageTotal.pageSize)"
        ></pagination>
      </el-tab-pane>
      <el-tab-pane label="总学习时长排行" name="second">
        <el-table
          v-if="activeName=='second'"
          :data="tableData"
          style="width: 100%;margin-top:16px"
          :header-cell-style="{background:'#EDF4FE'}"
          :height="height-160"
          class="collegeTable"
        >
          <el-table-column prop="num" label="名次"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="time" label="学习时长"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'first',
      height: window.innerHeight,
      tableData: [],
      pageTotal: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
    }
  },
  created() {
    this.getList(this.activeName)
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    getList(flag){
      if(flag == 'first'){
        this.tableData = [
          {
            num: '1',
            name: '张三',
            time: '10小时24分钟'
          },
          {
            num: '2',
            name: '张三',
            time: '10小时24分钟'
          },
        ]
      }else{
        this.tableData = [
          {
            num: '1',
            name: '张三',
            time: '10小时24分钟'
          },
          {
            num: '2',
            name: '李四',
            time: '10小时24分钟'
          },
        ]
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      this.activeName = tab.name
      this.getList(tab.name)
    },
    currentPageFn(val){
      this.loading = true;
      this.pageTotal.currentPage = val;
      this.getList();
    }
  },
}
</script>
<style lang="scss">
  .learning_duration_wrap{
    margin: 0 16px;
    padding: 0 16px;
    background: #fff;
    box-sizing: border-box;
    position: relative;
    .el-tabs{
      margin-top: 16px;
      .el-tabs__active-bar{
        background-color: #333;
      }
      .el-tabs__item{
        height: 54px;
        line-height: 54px;
        flex: none;
      }
      .el-tabs__item.is-active{
        color: #333;
        font-weight: 600;
      }
    }
    .go_back{
      width:72px;
      height:30px;
      background:rgba(255,255,255,1);
      border:1px solid #5397F7;
      border-radius:4px;
      color: #5397F7;
      font-size: 12px;
      position: absolute;
      right: 16px;
      top: 16px;
      padding: 0;
      cursor: pointer;
      z-index: 9;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/statistics/teacher/learningDuration.vue